/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle07Icon32Solid = forwardRef('NumberCircle07Icon32Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 29c7.18 0 13-5.82 13-13S23.18 3 16 3 3 8.82 3 16s5.82 13 13 13Zm4.268-19.019h-8.585v1.904h5.984a27.76 27.76 0 0 0-2.788 4.896c-.793 1.78-1.303 3.519-1.53 5.219h2.533c.261-1.87.794-3.723 1.598-5.559.805-1.836 1.734-3.417 2.788-4.743V9.981Z" })));
});
